<template>
  <div class="footer">
    <div>津ICP备15007925号-2</div>
    <div>Copyright 链接地址 <a href="https://beian.miit.gov.cn/">https://beian.miit.gov.cn/</a></div>
    <div>郑州码源信息技术有限公司</div>
  </div>
</template>

<script>
export default ({
  name: "Footer",
  methods: {
  }
})
</script>

<style lang="less">
.footer {
  min-height: 100px;
  width: 100vw;
  background: linear-gradient(to right, #B9CD48, #62CD48);
  color: #1B2D45;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: auto;
  @media screen and (max-width:650px) {
    padding-top: 30px;
    min-height: 220px;
    justify-content: start;
  }
}
</style>
